const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/sandboxes/$id/achievements.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { generateSandboxMeta } from "@/lib/generate-sandbox-meta";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/sandboxes/$id/achievements")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    context,
    params
  }) => {
    const {
      id
    } = params;
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["sandbox", "achievements", {
        id
      }],
      queryFn: () => httpClient.get<AchievementSet[]>(`/sandboxes/${id}/achievements`)
    });
    return {
      id,
      dehydratedState: dehydrate(queryClient)
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("sandboxes.notFoundTitle"),
          description: i18n.t("sandboxes.notFoundDescription")
        }]
      };
    }
    const {
      id
    } = params;
    const sandbox = getFetchedQuery<SingleSandbox>(queryClient, ctx.loaderData?.dehydratedState, ["sandbox", {
      id
    }]);
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData?.dehydratedState, ["sandbox", "base-game", {
      id
    }]);
    if (!sandbox) return {
      meta: [{
        title: i18n.t("sandboxes.notFoundTitle"),
        description: i18n.t("sandboxes.notFoundDescription")
      }]
    };
    return {
      meta: generateSandboxMeta(sandbox, offer, i18n.t("sandboxes.metaAchievementsTitle"))
    };
  }
});